var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,31.34c-5.31,0-10.85,2.18-13.37,4.84-.44,.46,2.87,2.74,2.98,2.63,1.31-1.28,5.28-3.47,10.39-3.47s9.06,2.19,10.38,3.46c.22,.21,3.87-1.71,2.96-2.65-2.53-2.65-8.05-4.81-13.34-4.81Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,29.69c5.51,0,10-4.49,10-10s-4.49-10-10-10-10,4.49-10,10,4.49,10,10,10Zm0-16c3.31,0,6,2.69,6,6s-2.69,6-6,6-6-2.69-6-6,2.69-6,6-6Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 19.69,
    r: 6,
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,2C11.87,2,2,11.87,2,24s9.87,22,22,22,22-9.87,22-22S36.13,2,24,2Zm0,7.69c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10Zm10.38,29.11c-1.32-1.28-5.29-3.46-10.38-3.46s-9.08,2.2-10.39,3.47c-.11,.11-3.42-2.17-2.98-2.63,2.52-2.66,8.06-4.84,13.37-4.84s10.8,2.16,13.34,4.81c.9,.94-2.74,2.87-2.96,2.65Z",
    fill: filledColor
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,46c-12.13,0-22-9.87-22-22S11.87,2,24,2s22,9.87,22,22-9.87,22-22,22Zm0-40C14.08,6,6,14.08,6,24s8.08,18,18,18,18-8.08,18-18S33.93,6,24,6Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,29.69c-5.51,0-10-4.49-10-10s4.49-10,10-10,10,4.49,10,10-4.49,10-10,10Zm0-16c-3.31,0-6,2.69-6,6s2.69,6,6,6,6-2.69,6-6-2.69-6-6-6Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.63,36.18c2.52-2.66,8.06-4.84,13.37-4.84s10.8,2.16,13.34,4.81c.9,.94-2.74,2.87-2.96,2.65-1.32-1.28-5.29-3.46-10.38-3.46s-9.08,2.2-10.39,3.47c-.11,.11-3.42-2.17-2.98-2.63Z",
    fill: outlineColor
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProfile);
export default __webpack_public_path__ + "static/media/ico-profile.b0e082b39b908b35ee483bee85c9d0d3.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;